import {shoppingCartService} from "../../network/services/shopping-cart.service";
import {ResponseError} from "../../network/response/response-error";
import bookingRoom from './booking-room.store';
import personal from './booking-personal.store'

export default {
    namespaced: true,
    state: {
        loading: false,
        paying: null,
    },
    mutations: {
        SET_BOOKING(state, payload) {
            state.booking = payload;
        },
        SET_LOADING(state, payload) {
            state.loading = !!payload;
        },
    },
    actions: {
        async reset(context) {
            context.commit('SET_LOADING', false);
            context.commit('SET_BOOKING', null);
            await context.dispatch('personal/reset');
        },
        async add({commit, rootState, dispatch}, {start, end, room_id, room_price_id, nb_guests, price_options}) {
            shoppingCartService.setAuth(rootState.client.tokens.accessToken);
            commit('SET_LOADING', true);
            const uuid = rootState.shoppingCart.uuid;
            shoppingCartService.setUuid(uuid);
            const response = await shoppingCartService.createBooking({
                start,
                end,
                room_id,
                room_price_id,
                nb_guests,
                price_options
            });
            const id = response.get('ShoppingCart.bookings.add.id');
            if (id instanceof ResponseError) {
                // TODO catch errors
                commit('SET_BOOKING', null);
                commit('SET_LOADING', false);
            } else {
                dispatch('shoppingCart/init', {lang: 'FR'}, {root: true});
                dispatch('fetch', id, {root: false});
            }
            return id;
        },
        async fetch(context, id) {
            context.commit('SET_LOADING', true);
            const uuid = context.rootState.shoppingCart.uuid;
            const token = context.rootState.client.tokens.accessToken;
            shoppingCartService.setAuth(context.rootState.client.tokens.accessToken);
            const lang = context.rootState["lang/currentLang"];
            shoppingCartService.setUuid(uuid);
            const response = await shoppingCartService.fetchBooking(id, token, lang);
            const booking = response.get('ShoppingCart.bookings', null);
            context.commit('SET_BOOKING', booking);
            context.commit('SET_LOADING', false);
        },
        async delete(context, id) {
            context.commit('shoppingCart/SET_LOADING', true, {root: true});
            shoppingCartService.setAuth(context.rootState.client.tokens.accessToken);
            shoppingCartService.setUuid(context.rootState.shoppingCart.uuid);
            await shoppingCartService.deleteBooking({id});
            await context.dispatch('shoppingCart/init', null, {root: true});
        },
        async update(context, {start, end, room_id, room_price_id, nb_guests, price_options, sc_booking_room_id}) {
            shoppingCartService.setAuth(context.rootState.client.tokens.accessToken);
            context.commit('SET_LOADING', true);
            const uuid = context.rootState.shoppingCart.uuid;
            shoppingCartService.setUuid(uuid);
            const response = await shoppingCartService.updateBooking({
                start,
                end,
                room_id,
                room_price_id,
                nb_guests,
                price_options,
                sc_booking_room_id,
            });
            const id = response.get('ShoppingCart.bookings.add.id');
            if (id instanceof ResponseError) {
                // TODO catch errors
                context.commit('SET_BOOKING', null);
                context.commit('SET_LOADING', false);
            } else {
                context.dispatch('shoppingCart/init', {lang: 'FR'}, {root: true});
                context.dispatch('fetch', id, {root: false});
            }
            return id;
        }
    },
    modules: {bookingRoom, personal}
}



// WEBPACK FOOTER //
// ./src/stores/shopping-cart/booking.store.js